import Vue from 'vue';
import PacklistService from '@/services/PacklistService';

class PackTrackingEventBus extends Vue {
    constructor() {
        super();
        this.packingSessions = new Map(); // Track active packing sessions
    }

    // Start pack tracking for an item
    async startPackTracking(packlistItemId, startTime = null) {
        try {
            // Check localStorage for existing session first
            let actualStartTime = startTime;
            
            if (!actualStartTime) {
                const currentPackSession = localStorage.getItem('lastTimestamp');
                if (currentPackSession) {
                    try {
                        const packSession = JSON.parse(currentPackSession);
                        actualStartTime = new Date(packSession.packStart);
                        console.log('🏁 EventBus: Using existing localStorage session:', actualStartTime);
                    } catch (e) {
                        console.warn('🏁 EventBus: Invalid localStorage session, creating new');
                        actualStartTime = new Date();
                    }
                } else {
                    actualStartTime = new Date();
                    console.log('🏁 EventBus: No existing session, creating new:', actualStartTime);
                }
            }
            
            console.log('🏁 EventBus: Starting pack tracking:', packlistItemId, actualStartTime);
            console.log('🏁 EventBus: actualStartTime type:', typeof actualStartTime, actualStartTime);
            
            // Store in localStorage
            const newPackSession = {
                packStart: actualStartTime.toISOString(), // Ensure consistent string format
                packlistItemId: packlistItemId
            };
            localStorage.setItem('lastTimestamp', JSON.stringify(newPackSession));
            console.log('🏁 EventBus: Stored in localStorage:', newPackSession);
            
            // Call the API
            await PacklistService.trackStart(packlistItemId, actualStartTime);
            
            // Store the session
            this.packingSessions.set(packlistItemId, {
                startTime: actualStartTime,
                active: true
            });
            
            // Emit event for components to listen
            this.$emit('pack-tracking-started', {
                packlistItemId,
                startTime: actualStartTime
            });
            
            console.log('✅ EventBus: Pack tracking started successfully');
            return true;
        } catch (error) {
            console.error('❌ EventBus: Error starting pack tracking:', error);
            this.$emit('pack-tracking-error', {
                packlistItemId,
                error: error.message,
                operation: 'start'
            });
            return false;
        }
    }

    // End pack tracking for an item
    async endPackTracking(packlistItemId) {
        try {
            console.log('🏁 EventBus: Ending pack tracking:', packlistItemId);
            
            // Call the API
            await PacklistService.trackEnd(packlistItemId);
            
            // Remove from active sessions
            this.packingSessions.delete(packlistItemId);
            
            // Emit event for components to listen
            this.$emit('pack-tracking-ended', {
                packlistItemId,
                endTime: new Date()
            });
            
            console.log('✅ EventBus: Pack tracking ended successfully');
            return true;
        } catch (error) {
            console.error('❌ EventBus: Error ending pack tracking:', error);
            this.$emit('pack-tracking-error', {
                packlistItemId,
                error: error.message,
                operation: 'end'
            });
            return false;
        }
    }

    // Get active session for an item
    getActiveSession(packlistItemId) {
        return this.packingSessions.get(packlistItemId);
    }

    // Check if item is being tracked
    isTracking(packlistItemId) {
        const session = this.packingSessions.get(packlistItemId);
        return session && session.active;
    }
}

const EventBus = new Vue();
const PackTracker = new PackTrackingEventBus();

export default EventBus;
export { PackTracker };